import moment from 'moment';
import { getCookie } from './cookies';

const cronRefreshToken = (refreshToken) => {

  const expireDate = getCookie("exp");
  if (!expireDate && expireDate !== 0) return () => {};

  //X => Timestamp in seconds
  const expirationTokenDate = moment(Number(expireDate || 0), 'X');
  let duration = moment.duration(
    expirationTokenDate.diff(moment())
  ).asMilliseconds();

  //Calcula milisegundos antes de 1min da data de expiração do token
  duration = (duration - 60000);

  if (!duration || duration <= 0) {
    // Realiza refresh caso a duração seja negativa ou inexistente
    refreshToken();
    return () => { }
  }

  let intervalId;
  const timeoutId = setTimeout(() => {
    refreshToken();
    // Cria novos refreshTokens a cada 9 min
    intervalId = setInterval(() => refreshToken(), 540000)
  }, duration);

  return () => {
    clearTimeout(timeoutId);
    intervalId && clearInterval(intervalId);
  }
};

export default cronRefreshToken;
